var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step step3"},[_c('step-header',{attrs:{"current":3}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }